export default {"src":"/_next/static/media/bottom_curve_new.5da20091.svg","height":390,"width":1920};